import React from "react";

// Small logo icon (used inline where a smaller mark is needed)
export const LogoMark = ({ className = "w-8 h-8" }) => (
  <img
    src="/brand/sommet-logo.png"
    srcSet="/brand/sommet-logo.png 1x, /brand/sommet-logo-hd.png 2x"
    alt="SOMMET ZÜRICH"
    className={className}
    style={{ objectFit: "contain", filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.55))" }}
  />
);

// Full logo (image with the mountains + SOMMET ZÜRICH wordmark below)
export const LogoFull = ({ className = "", size = 56 }) => (
  <img
    src="/brand/sommet-logo.png"
    srcSet="/brand/sommet-logo.png 1x, /brand/sommet-logo-hd.png 2x"
    alt="SOMMET ZÜRICH"
    className={className}
    style={{
      height: size,
      width: "auto",
      objectFit: "contain",
      display: "block",
      filter: "drop-shadow(0 4px 10px rgba(0,0,0,0.55))",
      imageRendering: "-webkit-optimize-contrast",
    }}
  />
);
